@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.sales-order {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.order-number {
  padding-bottom: 10px;
  color: @scan-page--order-sales-list-item-number--text-color;
  font-size: 20px;
}

.order-date-and-items {
  color: @scan-page--order-sales-list-item-date--text-color;
  display: flex;
  gap: @space-8;
}
